import './KMLUploader.css';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import KML from 'ol/format/KML';
import { Vector as VectorSource } from 'ol/source';
import { Vector } from 'ol/layer';
import { zoom, center } from '../../../../_config/map';

let vectorForKML = null;

function KMLUploader(props) {
  const { t } = useTranslation();

  const htmlElement = useRef();
  const feedbackElement = useRef();
  const [data, setData] = useState(undefined);
  const zIndexer = useState(props.map.getLayers().getArray().length)[0];

  const reader = new FileReader();

  const handleChange = (e) => {
    const files = e.target.files;
    if (files && files[0]) {
      setData(files[0]);
    }
  };

  const convertKMLToFeatures = () => {
    try {
      if (!data) return showErrorFeedback();

      handleReset();

      reader.onload = function () {
        try {
          const vector = new Vector({
            name: 'KML',
            title: 'KML',
            source: new VectorSource({
              url: reader.result,
              format: new KML()
            })
          });

          vector.setStyle();
          vector.setZIndex(zIndexer + 4);
          props.map.addLayer(vector);
          vectorForKML = vector;

          props.map.getView().setZoom(zoom);
          props.map.getView().setCenter(center);
        } catch (error) {
          console.error(error);
          showErrorFeedback();
        }
      };

      reader.readAsDataURL(data);
      props.callback();
    } catch (error) {
      console.error(error);
      showErrorFeedback();
    }
  };

  const handleReset = () => {
    if (vectorForKML) {
      props.map.removeLayer(vectorForKML);
      vectorForKML.getSource().clear();
      vectorForKML = undefined;
    }
  };

  const showErrorFeedback = () => {
    feedbackElement.current.style.visibility = 'visible';
  };

  useEffect(() => {
    if (data) convertKMLToFeatures();
  }, [data]);

  useEffect(() => {
    feedbackElement.current.style.visibility = 'hidden';
  }, []);

  return (
    <div className="KMLUploader">
      <h6>
        <label htmlFor="KMLFormFile" className="form-label">
          {t('kmlUploader.label')}
        </label>
      </h6>

      <div className="input-group mb-3">
        <input
          ref={htmlElement}
          className="form-control"
          id="KMLFormFile"
          type="file"
          accept=".kml,.KML"
          onChange={handleChange}
           style={{borderRadius: '10px 0px 0px 10px'}}
        />
        <span onClick={handleReset} className="input-group-text KMLUploaderReset">
          {t('kmlUploader.reset')}
        </span>
      </div>

      <div ref={feedbackElement} className="KMLUploaderErrorFeedback">
        {t('kmlUploader.error')}
      </div>
    </div>
  );
}

export default KMLUploader;
